export const getLeftSideWrapperStyles = (isLogin: boolean) => ({
  pt: {
    xs: isLogin ? 5 : 3,
    md: isLogin ? 32 : 22,
    lg: isLogin ? 38 : 22,
  },
  pb: {
    xs: 7.5,
    md: isLogin ? 26 : 22,
    lg: isLogin ? 32 : 22,
  },
});
